import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'How close is it to Appalachian State University?',
      answer: 'App State is directly across the street from The Summit on King! Just cross the street and you are on campus.'
    },
    {
      question: 'Is the property on King Street?',
      answer: 'Yes. The Summit on King includes buildings directly on King Street across from Appalachian State University, placing residents steps from campus and the heart of Downtown Boone. We also offer apartments just above King Street on Wallace Circle - providing a quieter setting while still only seconds from downtown.'
    },
    {
      question: 'Is parking available?',
      answer: 'Yes. On-site parking is available for residents for $125 / month. Parking permits are provided for those who select on-site parking.'
    },
    {
      question: 'What utilities are included in the rent?',
      answer: 'Trash removal is included. Residents pay a flat $35 fee for water each month. Residents are responsible for electricity and internet. Apartments are new and energy efficient, so utility costs are typically low. Residents set up accounts directly with New River Power for electricity and Spectrum for internet.'
    },
    {
      question: 'What appliances are included?',
      answer: 'All units include stainless steel appliances: refrigerator, stove, oven, dishwasher, microwave, and an in-unit washer and dryer.'
    },
    {
      question: 'Are the apartments furnished?',
      answer: 'No. Apartments are unfurnished, allowing residents to personalize their space. All major appliances are included.'
    },
    {
      question: 'Are pets allowed?',
      answer: 'No. The Summit on King is a pet-free property.'
    },
    {
      question: 'Do you allow roommates?',
      answer: 'Yes. Many of our apartments are shared by roommates. All residents must complete an application and be approved prior to signing the lease.'
    },
    {
      question: 'What is the lease term?',
      answer: 'Standard leases are 12 months. Leases typically begin in late July or early August. Contact us for flexibility on move-in dates.'
    },
    {
      question: 'Is there a security deposit?',
      answer: 'Yes. A security deposit is required at lease execution. Amounts vary by unit type and lease terms.'
    },
    {
      question: 'What shopping and dining options are nearby?',
      answer: 'The Summit on King is located in the heart of Downtown Boone, with restaurants, coffee shops, and everyday essentials just steps away. Earth Fare is within walking distance, and Publix, Food Lion, and Walmart are a short drive from the property.'
    },
    {
      question: 'Is smoking allowed?',
      answer: 'No. The Summit on King is a non-smoking property.'
    },
    {
      question: 'Do you offer tours?',
      answer: 'Each unit has a dedicated page with photos, floor plans, and a video tour so you can explore the apartments remotely.'
    },
    {
      question: 'Can I use a guarantor if I do not meet the income requirements?',
      answer: 'Yes. Applicants who do not meet the income requirement may qualify with a guarantor who meets the required financial criteria.'
    },
    {
      question: 'What is the application process?',
      answer: 'Submit an online application. Our team will follow up with next steps. Proof of income equal to three times the monthly rent is required, or a lease guarantor if income requirements are not met. Contact us with any questions.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="w-full">
      {/* Hero Section */}
      <section className="bg-[#FF5722] text-white py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-black mb-4">FREQUENTLY ASKED QUESTIONS</h1>
          <p className="text-xl">Everything you need to know about The Summit on King</p>
        </div>
      </section>

      {/* FAQs Section */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="border border-gray-200 rounded-lg overflow-hidden hover:border-[#FF5722] transition-colors"
              >
                <button
                  className="w-full px-6 py-5 text-left flex justify-between items-center bg-white hover:bg-gray-50 transition-colors"
                  onClick={() => toggleFAQ(index)}
                >
                  <span className="font-semibold text-lg pr-4">{faq.question}</span>
                  <ChevronDown 
                    className={`w-6 h-6 text-[#FF5722] flex-shrink-0 transition-transform duration-200 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                <div 
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <div className="px-6 py-4 bg-gray-50 text-gray-700 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQs;
